module.exports = __webpack_public_path__ + "static/img/biyuntao.0cd9c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/fl/biyuntao.png
// module id = koLj
// module chunks = 0